import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage,
    ValidationMessageType, SettingState, TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';

export default class AzureProperty extends BaseFeature {
    constructor() {
        super();
        this.name = 'Azure Property';
        this.id = 'azure_property';
        this.singleInstance = false;
        this.devices = ['WM2000', 'WM2000EV', 'WS1102'];
        this.settings = this.settings.concat([
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                helpText: 'Name of the property. This has to match the name of the property in the Azure IoT Central.',
                required: true,
                default: 'Property_Name',
            },
            {
                id: 'PROPERTY_ID',
                name: 'Connected Setting Name',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
                refId: 'stg_setting',
                options: [],
            },
        ]);
    }

    getDependencies() {
        const dependencies = [
            'azure',
        ];
        return dependencies;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        const PROPERTY_ID = this.getSettingValue('PROPERTY_ID');
        const setting = this.project.getFeature(PROPERTY_ID);
        if (!setting) {
            return blocks;
        }

        const NAME = this.getSettingValue('NAME');
        const SETTINGID = setting.getSettingValue('SETTINGID');

        blocks.push({
            location: 'callback_azure_property_desired',
            blockType: BlockType.CODE,
            template: `
    case "${NAME}":
        var_${SETTINGID}_set(property_value)`,
        });

        blocks.push({
            location: 'callback_mqtt_connect_ok',
            blockType: BlockType.CODE,
            template: `
    azure_send_property("${NAME}",${SETTINGID})
        `,
        });

        blocks.push({
            location: `var_${SETTINGID}_set`,
            blockType: BlockType.CODE,
            template: `
    azure_send_property("${NAME}",${SETTINGID})`,
        });

        return blocks;
    }
}
